<template>
  <div class="hero-section">
    <h1 class="hero-text">You're going to die.</h1>
    <h2 class="subheading">And that's okay.</h2>
    <h2 class="subheading closer">As long as you live accordingly.</h2>
    <img alt="Temporal logo" src="../assets/logo.svg" class="logo">
    <p class="message">
      Be aware that the time you have left is finite.<br>
      Be aware that the time you have left is yours.<br>
      Be intentional with how you spend that time.<br>
      <span class="slogan">Be Temporal.</span>
    </p>
  </div>
  <div class="social-links">
    <a href="https://instagram.com/betemporal" target="_blank" rel="noopener noreferrer">
      <i class="fab fa-instagram"></i>
    </a>
    <a href="https://x.com/betemporal" target="_blank" rel="noopener noreferrer">
      <i class="fab fa-x-twitter"></i>
    </a>
    <a href="https://tiktok.com/@betemporal" target="_blank" rel="noopener noreferrer">
      <i class="fab fa-tiktok"></i>
    </a>
    <a href="https://www.youtube.com/channel/UCzn-t0n5d8NDnC1HTfShT2w" target="_blank" rel="noopener noreferrer">
      <i class="fab fa-youtube"></i>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: "HomePage",
});
</script>

<style scoped>
.hero-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.social-links {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style> 